module.exports = __webpack_public_path__ + "static/media/logo-keno.a3d4414d.png";